// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.web-container {
  margin: 0 auto;
  padding: 0 15px;
  width: 100%;
/*  max-width: 600px; */
}

@media screen and (max-width: 575px) {
  .web-container {
    padding: 0 8px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,eAAe;EACf,WAAW;AACb,uBAAuB;AACvB;;AAEA;EACE;IACE,cAAc;EAChB;AACF","sourcesContent":[".web-container {\n  margin: 0 auto;\n  padding: 0 15px;\n  width: 100%;\n/*  max-width: 600px; */\n}\n\n@media screen and (max-width: 575px) {\n  .web-container {\n    padding: 0 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
